import { QueryParamsModel } from "./query-params.state";

export class QueryParamsAction {
  static readonly type = '[QueryParams] QueryParams';

  constructor(public payload: QueryParamsModel) {}
}